/* 27.09.2026 — MUSE-Kaufbox (snippets/rlk-muse.liquid). Laedt nach rlk.js (defer).
   Nur echte Daten: Bewertungen aus [data-rlk-rev-daten] (Lieferanten-Bewertungen,
   Herkunftszeile steht im Titelblock), Lieferdaten aus RLK.logik (Werktage, Feiertage). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var OSTASIATISCH = /[぀-ヿ㐀-䶿一-鿿豈-﫿가-힯]/;
  var LATEIN_BUCHSTABE = /[A-Za-zÄÖÜäöüß]/;
  var PLATTFORM = new RegExp(['ali', 'ex', 'press'].join('\\s*') + '|chin' + 'a', 'i');

  /* ---------- Rabattcode kopieren ---------- */
  function initCode() {
    $$('[data-muse-code-kopieren]').forEach(function (k) {
      k.addEventListener('click', function () {
        var code = k.getAttribute('data-muse-code-kopieren');
        var ok = k.querySelector('[data-muse-code-ok]');
        function zeigen() { if (ok) { ok.hidden = false; setTimeout(function () { ok.hidden = true; }, 1800); } }
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(zeigen, zeigen);
          else zeigen();
        } catch (e) { zeigen(); }
      });
    });
  }

  /* ---------- Bewertungen ---------- */
  function bewertungen() {
    var k = $('[data-rlk-rev-daten]');
    if (!k) return [];
    try { var a = JSON.parse(k.textContent); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function nameLesbar(n) {
    n = (n || '').trim();
    if (!n || /^(anonym|käufer|kaeufer)$/i.test(n) || PLATTFORM.test(n) || OSTASIATISCH.test(n)) return null;
    for (var i = 0; i < n.length; i++) { var z = n.charAt(i); if (/\p{L}/u.test(z) && !LATEIN_BUCHSTABE.test(z) && !/\p{Script=Latin}/u.test(z)) return null; }
    return n;
  }
  function initiale(n) { var z = (n || '').trim().charAt(0); return /\p{L}/u.test(z) ? z.toUpperCase() : null; }
  function textLesbar(b) { return b && b.length >= 25 && b.length <= 280 && !OSTASIATISCH.test(b); }
  function sterne(r) { var s = ''; for (var i = 1; i <= 5; i++) s += i <= r ? '★' : '☆'; return s; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function nachDatum(a, b) { return (b.d || '').localeCompare(a.d || ''); }

  function initSozial(liste) {
    $$('[data-muse-sozial]').forEach(function (box) {
      var anzahl = parseInt(box.getAttribute('data-anzahl'), 10) || 0;
      var namen = [], gesehen = {};
      liste.slice().sort(nachDatum).forEach(function (r) {
        if (namen.length >= 3 || (r.r || 0) < 4) return;
        var n = nameLesbar(r.n); var i = n && initiale(n);
        if (i && !gesehen[i]) { gesehen[i] = true; namen.push(i); }
      });
      if (namen.length < 3 || anzahl < 3) return;
      $('[data-muse-avatare]', box).innerHTML = namen.map(function (i, k) { return '<span class="rlk-muse-av rlk-muse-av--' + k + '">' + esc(i) + '</span>'; }).join('');
      $('[data-muse-namen]', box).textContent = namen.map(function (i) { return i + '.'; }).join(', ');
      var rest = anzahl - namen.length;
      $('[data-muse-weitere]', box).textContent = rest > 0 ? 'und ' + rest.toLocaleString('de-DE') + ' weitere Bewertungen' : '';
      box.hidden = false;
    });
  }

  function initKarte(liste) {
    if (!Array.isArray(liste)) return;
    $$('[data-muse-karte]').forEach(function (box) {
      if (box.hasAttribute('data-muse-karte-ready')) return;
      var auswahl = liste.filter(function (r) { return (r.r || 0) >= 4 && textLesbar(r.b); })
        .sort(function (a, b) { var la = a.b.length >= 60 ? 1 : 0, lb = b.b.length >= 60 ? 1 : 0; return (lb - la) || ((b.p && b.p.length ? 1 : 0) - (a.p && a.p.length ? 1 : 0)) || nachDatum(a, b); })
        .slice(0, 6);
      if (!auswahl.length) return;
      var buehne = $('[data-muse-karte-buehne]', box), nav = $('[data-muse-karte-nav]', box);
      var zurueck = $('[data-muse-karte-zurueck]', box), vor = $('[data-muse-karte-vor]', box);
      var position = $('[data-muse-karte-position]', box), i = 0;
      if (!buehne || !nav || !zurueck || !vor || !position) return;
      var kaeufer = box.getAttribute('data-muse-karte-buyer');
      var fotoText = box.getAttribute('data-muse-karte-photo');
      var sterneText = box.getAttribute('data-muse-karte-stars');
      var positionText = box.getAttribute('data-muse-karte-slide-label');
      var slideText = box.getAttribute('data-muse-karte-slide-role');
      function positionLabel(index) {
        return positionText.replace('__current__', String(index + 1)).replace('__total__', String(auswahl.length));
      }
      buehne.innerHTML = auswahl.map(function (r, index) {
        var name = nameLesbar(r.n) || kaeufer;
        var foto = r.p && r.p.length ? '<img class="rlk-muse-karte__foto" src="' + esc(r.p[0]) + '" alt="' + esc(fotoText) + '" width="56" height="56" loading="lazy" referrerpolicy="no-referrer" draggable="false">' : '<span class="rlk-muse-karte__foto rlk-muse-karte__foto--leer" aria-hidden="true">' + esc(initiale(name) || 'K') + '</span>';
        return '<div class="rlk-muse-karte__slide' + (index === 0 ? ' is-active' : '') + '" data-muse-karte-slide data-active="' + (index === 0 ? 'true' : 'false') + '" role="group" aria-roledescription="' + esc(slideText) + '" aria-label="' + esc(positionLabel(index)) + '" aria-hidden="' + (index === 0 ? 'false' : 'true') + '"' + (index === 0 ? '' : ' inert') + '>' + foto +
          '<div class="rlk-muse-karte__inhalt"><p class="rlk-muse-karte__kopf"><b>' + esc(name) + '</b>' +
          '<span class="rlk-muse-karte__haken" aria-label="' + esc(kaeufer) + '"><svg viewBox="0 0 20 20" width="13" height="13" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="currentColor"/><path d="M6 10.3l2.6 2.6L14 7.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '<span class="rlk-muse-karte__sterne" aria-label="' + esc(sterneText.replace('__rating__', String(r.r))) + '">' + sterne(r.r) + '</span></p>' +
          '<p class="rlk-muse-karte__text">' + esc(r.b) + '</p></div></div>';
      }).join('');
      var slides = $$('[data-muse-karte-slide]', buehne);
      function zeige(index) {
        i = (index + auswahl.length) % auswahl.length;
        slides.forEach(function (slide, slideIndex) {
          var aktiv = slideIndex === i;
          slide.classList.toggle('is-active', aktiv);
          slide.setAttribute('data-active', aktiv ? 'true' : 'false');
          slide.setAttribute('aria-hidden', aktiv ? 'false' : 'true');
          slide.toggleAttribute('inert', !aktiv);
        });
        position.textContent = (i + 1) + ' / ' + auswahl.length;
        position.setAttribute('aria-label', positionLabel(i));
      }
      if (auswahl.length > 1) {
        nav.hidden = false;
        zurueck.addEventListener('click', function () { zeige(i - 1); });
        vor.addEventListener('click', function () { zeige(i + 1); });
        buehne.tabIndex = 0;
        box.addEventListener('keydown', function (event) {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          zeige(i + (event.key === 'ArrowRight' ? 1 : -1));
        });
        var geste = null;
        buehne.addEventListener('pointerdown', function (event) {
          if (!event.isPrimary) { geste = null; return; }
          if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
          geste = { id: event.pointerId, x: event.clientX, y: event.clientY };
        }, { passive: true });
        buehne.addEventListener('pointermove', function (event) {
          if (!geste || geste.id !== event.pointerId) return;
          var dx = Math.abs(event.clientX - geste.x), dy = Math.abs(event.clientY - geste.y);
          if (dy > 12 && dy > dx) geste = null;
        }, { passive: true });
        buehne.addEventListener('pointerup', function (event) {
          if (!geste || geste.id !== event.pointerId) return;
          var dx = event.clientX - geste.x, dy = event.clientY - geste.y;
          geste = null;
          if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.3) zeige(i + (dx < 0 ? 1 : -1));
        }, { passive: true });
        buehne.addEventListener('pointercancel', function () { geste = null; }, { passive: true });
      }
      zeige(0);
      box.setAttribute('data-muse-karte-ready', 'true');
      box.hidden = false;
    });
  }

  function initUgc(liste) {
    $$('[data-muse-ugc]').forEach(function (box) {
      var fotos = [], gesehen = {};
      liste.slice().sort(nachDatum).forEach(function (r) {
        if ((r.r || 0) < 4 || !r.p) return;
        r.p.forEach(function (u) { if (fotos.length < 3 && u && !gesehen[u]) { gesehen[u] = true; fotos.push(u); } });
      });
      if (fotos.length < 3) return;
      $('[data-muse-ugc-reihe]', box).innerHTML = fotos.map(function (u) {
        return '<li><a href="#rlk-reviews" aria-label="Zu den Bewertungen"><img src="' + esc(u) + '" alt="Kundenfoto aus einer Bewertung" loading="lazy" referrerpolicy="no-referrer" width="200" height="260"></a></li>';
      }).join('');
      box.hidden = false;
    });
  }

  /* ---------- Lieferzeitleiste ----------
     08.10.2026 (GLUTORA, Nachbesserung 1): Countdown und Kalenderdaten entfernt.
     Der Kopf versprach ein festes Zustelldatum ("bekommst du es bis ..."), die
     Versandseite sagt aber: Lieferzeiten sind Schaetzungen, keine garantierten
     Termine. Kopf und Leiste kommen jetzt unveraendert aus dem Liquid
     (snippets/rlk-muse.liquid, teil 'zeitleiste', LAF-Lieferzusage mit
     200-EUR-Schwelle); den Variantenwechsel uebernimmt rlk.js ueber
     [data-delivery-promise]. Hier ist dafuer nichts mehr zu tun. */

  function start() {
    initCode();
    var liste = bewertungen();
    if (liste.length) { initSozial(liste); initKarte(liste); initUgc(liste); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
